import { useCallback, useEffect, useRef, useState } from 'react';
import moment from 'moment-timezone';

interface Props {
  time: number;
  interval?: number;
  startTime?: number;
  onTimeout?: () => void;
}
export const UTC_OFFSET = '+07:00';

const useCountDown = (props: Props) => {
  const momentTz = moment().utcOffset(UTC_OFFSET).format('HH:mm:ss DD/MM/YYYY');
  const {
    time,
    interval = 1000,
    startTime = moment(momentTz, 'HH:mm:ss DD/MM/YYYY').valueOf(),
    onTimeout,
  } = props;

  const [timeRemaining, setTimeRemaining] = useState(time);
  const endTime = useRef(startTime + time);

  const resetCountDown = useCallback(
    (newTime?: number) => {
      endTime.current =
        moment(momentTz, 'HH:mm:ss DD/MM/YYYY').valueOf() + (newTime ?? time);
      setTimeRemaining(newTime ?? time);
    },
    [time],
  );

  useEffect(() => {
    const runCountDown = () => {
      const momentTzNow = moment()
        .utcOffset(UTC_OFFSET)
        .format('HH:mm:ss DD/MM/YYYY');
      const newTimeRemaining =
        endTime.current - moment(momentTzNow, 'HH:mm:ss DD/MM/YYYY').valueOf();

      if (newTimeRemaining <= 0 || timeRemaining <= 0) {
        onTimeout?.();
        clearInterval(timer);
        return setTimeRemaining(0);
      }
      setTimeRemaining(Math.round(newTimeRemaining / 1000) * 1000);
    };

    const timer = setInterval(runCountDown, interval);

    return () => {
      clearInterval(timer);
    };
  }, [interval, timeRemaining]);

  return {
    timeRemaining,
    resetCountDown,
  };
};

export default useCountDown;
